<template>
    <base-modal :value="value" @input="canceled"
        body-classes="p-0" :size="size"
        :loading="loading"
        :backdrop="backdrop"
        :animationDuration="animationDuration"
        :centered="centered"
    >
        <card type="secondary"
            header-classes="bg-transparent"
            :body-classes="mergedBodyClasses"
            class="border-0 mb-0">

            <template slot="header" v-if="title">
                <h6 class="modal-title text-left text-uppercase">
                    {{ title }}
                </h6>
                <button type="button"
                        class="close"
                        @click="value.show=false"
                        data-dismiss="modal"
                        aria-label="Close">
                    <span>×</span>
                </button>
            </template>

            <template>
                <slot></slot>
            </template>
        </card>

    </base-modal>
</template>

<script>
    export default {
        
        props: {
            value: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                default: null
            },
            size: {
                type: String,
                default: null
            },
            loading: {
                type: Boolean,
                default: false
            },
            bodyClasses: {
                type: String,
                default: ''
            },
            centered: {
                type: Boolean,
                default: true
            },
            backdrop: {
                type: String,
                default: 'static'
            },
            animationDuration: {
                type: Number,
                default: 500
            },
            scrollReset: {
                type: Boolean,
                default: true
            },
        },
        
        computed: {

            definedTitle() {
                return this.title || this.$t('common.confirm-question')
            },

            mergedBodyClasses() {
                return this.bodyClasses ? this.bodyClasses : 'px-lg-4 py-lg-4 '
            }
        },

        watch: {
            value(val) {
                if (val.show && this.scrollReset) {
                    // Scroll to the top of the modal when reopened.
                    this.$nextTick(() => {
                        this.$el.scrollTop = 0
                    })
                }
            }
        },

        methods: {

            confirmed() {
                //$('#'+this.value.id).modal('hide')
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                    confirmed: true,
                    data: this.value.data
                })
            },

            canceled() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                    confirmed: false,
                    data: this.value.data
                })
            }
        }
    }
</script>

<style scoped>

    .modal-title {
        text-transform: uppercase;
    }
    button.close {
        padding-right: 1rem;
        margin: -1rem -1rem -1rem auto;
    }

</style>